var _style, _rect, _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 170.1 47.3",
    style: {
      enableBackground: "new 0 0 170.1 47.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{display:none;fill:#FFFFFF;} .st1{fill:#1D1D1B;} .st2{fill:#C31000;} ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0,
    className: "st0",
    width: 169.4,
    height: 47.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120,13.4v20.5h6.2v-8.2h11V13.4H120z M131.4,21.6h-5.3v-4.1h5.3V21.6z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "158.4,13.4 141.1,13.4 141.1,17.5 146.7,17.5 146.7,33.9 152.8,33.9 152.8,17.5 158.4,17.5 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "11.8,13.4 11.8,17.5 22.8,17.5 22.8,21.6 15.9,21.6 15.9,25.7 22.8,25.7 22.8,29.8 11.8,29.8 11.8,33.9 28.9,33.9 28.9,13.4 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "115.8,17.5 115.8,13.4 98.7,13.4 98.7,33.9 115.8,33.9 115.8,29.8 104.9,29.8 104.9,25.7 111.8,25.7 111.8,21.6 104.9,21.6 104.9,17.5 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "75.4,13.4 75.4,33.9 81.6,33.9 81.6,17.5 88.5,17.5 88.5,33.9 94.7,33.9 94.7,13.4 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "46.1,13.4 39.2,21.6 39.2,13.4 33,13.4 33,33.9 39.2,33.9 39.2,25.7 45.7,33.9 50.1,33.9 50.1,29.8 44.2,22.3 48.2,17.5 50.1,17.5 50.1,13.4 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "54.3,13.4 54.3,33.9 71.4,33.9 71.4,29.8 60.4,29.8 60.4,17.5 67.3,17.5 67.3,19.3 71.4,19.3 71.4,13.4 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.8,3.8h162.4v39.6H3.8V3.8z M0,47.3h170.1V0H0V47.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/__.37aab3722c485b6be338ccf90e097b91.svg";
export { ForwardRef as ReactComponent };